import angular from 'angular'

import { wrap, uniqueId, includes } from 'lodash-es'
import { isText, defaultTo, isPosInteger } from '../utils/bits'

import envRaw from '../utils/env-raw'
import Emitter from '../utils/emitter'
import StrictObj from '../utils/strict-obj'
import attachEmitters from '../utils/attach-emitters'

import Template from './gallery-header.component.ejs'

angular
  .module('ggs.gallery-header')
  .component('ggsGalleryHeader', {
    template: Template(StrictObj({
      LE: envRaw.liveEditMode
    })),
    controller: GalleryHeaderComponent,
    bindings: {
      ggsStylerNew: '<',
      ggsProperties: '<'
    }
  })

function GalleryHeaderComponent(
  $log, $scope,
  qh, debugObj,
  DefineHandler, DefineMethod,
  GalleryHeaderStyleHandlers) {

  const sign = `galleryHeader[uid=${uniqueId()}]`
  const $ctrl = $scope.$ctrl = debugObj(sign, StrictObj(this))
  $ctrl.wrapM = DefineMethod(sign)
  $ctrl.wrapH = DefineHandler(sign)

  $ctrl.contentHeight = undefined
  $ctrl.contentHeightEmitter = Emitter(`${sign}::contentHeight`)

  const styleHandlers = GalleryHeaderStyleHandlers(descBgType)

  // $onInit
  $ctrl.wrapM('attachToStyler',
    qh.makeCatch(
      wrap(styleHandlers, $ctrl.ggsStylerNew.reg),
      wrap(`${sign}#attachToStyler: error halted:`, $log.error)))

  $ctrl.wrapH('$onInit',
    $ctrl.attachToStyler)

  // $onDestroy
  $ctrl.wrapH('$onDestroy',
    wrap(styleHandlers, $ctrl.ggsStylerNew.release))

  // actual cover image
  $ctrl.getCoverImageSrc = () =>
    $ctrl.ggsProperties.image

  $ctrl.hasCoverImageSrc = () =>
    isText($ctrl.ggsProperties.image)

  // cover height
  $ctrl.getCoverColorSolidHeight = attachEmitters(
    () => isPosInteger($ctrl.ggsProperties.cover_solid_height)
            ? $ctrl.ggsProperties.cover_solid_height
            : $ctrl.contentHeight,
    $ctrl.contentHeightEmitter,
    $ctrl.ggsProperties.key2emitter.cover_solid_height)

  $ctrl.getCoverColorGradientHeight = attachEmitters(
    () => isPosInteger($ctrl.ggsProperties.cover_gradient_height)
            ? $ctrl.ggsProperties.cover_gradient_height
            : $ctrl.contentHeight,
    $ctrl.contentHeightEmitter,
    $ctrl.ggsProperties.key2emitter.cover_gradient_height)

  $ctrl.getCoverImageClippedHeight = attachEmitters(
    () => isPosInteger($ctrl.ggsProperties.cover_image_height)
            ? $ctrl.ggsProperties.cover_image_height
            : null,
    $ctrl.ggsProperties.key2emitter.cover_image_height)

  // hasCover
  $ctrl.hasCover = () => false
    || $ctrl.hasCoverImage()
    || $ctrl.hasCoverBackground()

  // cover image
  $ctrl.hasCoverClippedImage = () => true
    && $ctrl.hasCoverImage()
    && isPosInteger($ctrl.ggsProperties.cover_image_height)

  $ctrl.hasCoverFullImage = () => true
    && $ctrl.hasCoverImage()
    && !isPosInteger($ctrl.ggsProperties.cover_image_height)

  $ctrl.hasCoverImage = () => true
    && $ctrl.ggsProperties.header_show_cover
    && descBgType($ctrl.ggsProperties.header_cover_bg_type).isImage
    && (false
      || isText($ctrl.ggsProperties.image)
      || isText($ctrl.ggsProperties.image_background))

  // cover background
  $ctrl.hasCoverBackground = () => false
    || $ctrl.hasCoverGradientBackground()
    || $ctrl.hasCoverSolidBackground()

  $ctrl.hasCoverGradientBackground = () => true
    && $ctrl.ggsProperties.header_show_cover
    && descBgType($ctrl.ggsProperties.header_cover_bg_type).isGrdnt
    && isText($ctrl.ggsProperties.header_background)

  $ctrl.hasCoverSolidBackground = () => true
    && $ctrl.ggsProperties.header_show_cover
    && descBgType($ctrl.ggsProperties.header_cover_bg_type).isSolid
    && isText($ctrl.ggsProperties.header_solid_background)

  // logo
  $ctrl.hasLogo = () => true
    && $ctrl.ggsProperties.header_show_logo
    && isText($ctrl.ggsProperties.logo)

  // name
  $ctrl.hasName = () => true
    && $ctrl.ggsProperties.header_show_text
    && isText($ctrl.ggsProperties.header_display_name)

  $ctrl.getNameText = () =>
    defaultTo($ctrl.ggsProperties.header_display_name, null)

  // desc
  $ctrl.hasDesc = () => true
    && $ctrl.ggsProperties.header_show_text
    && isText($ctrl.ggsProperties.description)

  $ctrl.getDescText = () =>
    defaultTo($ctrl.ggsProperties.description, null)

  // links
  $ctrl.hasSomeSocialUrls = () => true
    && $ctrl.ggsProperties.header_show_urls
    && (false
      || !!$ctrl.ggsProperties.facebook_url
      || !!$ctrl.ggsProperties.twitter_url
      || !!$ctrl.ggsProperties.instagram_url
      || !!$ctrl.ggsProperties.tumblr_url
      || !!$ctrl.ggsProperties.youtube_url
      || !!$ctrl.ggsProperties.soundcloud_url
      || !!$ctrl.ggsProperties.pinterest_url
      || !!$ctrl.ggsProperties.website_url)

  // helpers
  function descBgType(header_cover_bg_type) {
    return StrictObj({
      isSolid: header_cover_bg_type === 'solid',
      isImage: header_cover_bg_type === 'image',
      isGrdnt: header_cover_bg_type === 'gradient',
      isKnown: includes(['solid', 'image', 'gradient'], header_cover_bg_type)
    })
  }
}
